<script setup>

import { useStore } from "vuex";
import { onBeforeMount } from 'vue';
import bootstrap from "bootstrap/dist/js/bootstrap";
import axios from "axios";
import validSession from "../assets/js/valid-session";
import { toast } from 'vue3-toastify';
import loadGif from "@/assets/img/loading.gif"
import ObjetivesRow from "../components/ObjetivesRow.vue";
import { computed } from "vue";

const colors = [
    "#FFB3B3", "#FFCCBC", "#FFECB3", "#FFF9C4", "#DCEDC8", "#C8E6C9",
    "#B2EBF2", "#B3E5FC", "#B2DFDB", "#D1C4E9", "#E1BEE7", "#F8BBD0",
    "#EF9A9A", "#FFAB91", "#FFD180", "#FFF59D", "#AED581", "#81C784",
    "#4DB6AC", "#4FC3F7", "#64B5F6", "#7986CB", "#BA68C8", "#F06292",
    "#E57373", "#F48FB1", "#CE93D8", "#9575CD", "#7986CB", "#4FC3F7",
    "#4DD0E1", "#4DB6AC", "#81C784", "#AED581", "#FFF176", "#FFD54F",
    "#FFB74D", "#FF8A65", "#A1887F", "#E0E0E0", "#90A4AE", "#A5D6A7",
    "#C5E1A5", "#E6EE9C", "#FFF176", "#FFD54F", "#FFB74D", "#FF8A65",
    "#FF7043", "#8D6E63", "#BDBDBD", "#78909C", "#F44336", "#E91E63",
    "#9C27B0", "#673AB7", "#3F51B5", "#03A9F4", "#009688", "#4CAF50"
  ]

const value_objetive = {
    value: 0
};

const money = {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false /* doesn't work with directive */
        }

let icons = [];

let icons_new = [
  {
    "name": "Utensils",
    "icon": "utensils",
    "class": "fa-utensils",
    "group": "Alimentação"
  },
  {
    "name": "Coffee",
    "icon": "coffee",
    "class": "fa-coffee",
    "group": "Alimentação"
  },
  {
    "name": "Hamburger",
    "icon": "hamburger",
    "class": "fa-hamburger",
    "group": "Alimentação"
  },
  {
    "name": "Pizza Slice",
    "icon": "pizza-slice",
    "class": "fa-pizza-slice",
    "group": "Alimentação"
  },
  {
    "name": "Apple Alt",
    "icon": "apple-alt",
    "class": "fa-apple-alt",
    "group": "Alimentação"
  },
  {
    "name": "Carrot",
    "icon": "carrot",
    "class": "fa-carrot",
    "group": "Alimentação"
  },
  {
    "name": "Ice Cream",
    "icon": "ice-cream",
    "class": "fa-ice-cream",
    "group": "Alimentação"
  },
  {
    "name": "Lemon",
    "icon": "lemon",
    "class": "fa-lemon",
    "group": "Alimentação"
  },
  {
    "name": "Fish",
    "icon": "fish",
    "class": "fa-fish",
    "group": "Alimentação"
  },
  {
    "name": "Bread Slice",
    "icon": "bread-slice",
    "class": "fa-bread-slice",
    "group": "Alimentação"
  },
  {
    "name": "Egg",
    "icon": "egg",
    "class": "fa-egg",
    "group": "Alimentação"
  },
  {
    "name": "Cheese",
    "icon": "cheese",
    "class": "fa-cheese",
    "group": "Alimentação"
  },
  {
    "name": "Hotdog",
    "icon": "hotdog",
    "class": "fa-hotdog",
    "group": "Alimentação"
  },
  {
    "name": "Drumstick Bite",
    "icon": "drumstick-bite",
    "class": "fa-drumstick-bite",
    "group": "Alimentação"
  },
  {
    "name": "Wine Bottle",
    "icon": "wine-bottle",
    "class": "fa-wine-bottle",
    "group": "Alimentação"
  },
  {
    "name": "Wine Glass",
    "icon": "wine-glass",
    "class": "fa-wine-glass",
    "group": "Alimentação"
  },
  {
    "name": "Beer",
    "icon": "beer",
    "class": "fa-beer",
    "group": "Alimentação"
  },
  {
    "name": "Cocktail",
    "icon": "cocktail",
    "class": "fa-cocktail",
    "group": "Alimentação"
  },
  {
    "name": "Glass Martini",
    "icon": "glass-martini",
    "class": "fa-glass-martini",
    "group": "Alimentação"
  },
  {
    "name": "Mug Hot",
    "icon": "mug-hot",
    "class": "fa-mug-hot",
    "group": "Alimentação"
  },
  {
    "name": "Car",
    "icon": "car",
    "class": "fa-car",
    "group": "Transporte"
  },
  {
    "name": "Bus",
    "icon": "bus",
    "class": "fa-bus",
    "group": "Transporte"
  },
  {
    "name": "Bicycle",
    "icon": "bicycle",
    "class": "fa-bicycle",
    "group": "Transporte"
  },
  {
    "name": "Motorcycle",
    "icon": "motorcycle",
    "class": "fa-motorcycle",
    "group": "Transporte"
  },
  {
    "name": "Plane",
    "icon": "plane",
    "class": "fa-plane",
    "group": "Transporte"
  },
  {
    "name": "Train",
    "icon": "train",
    "class": "fa-train",
    "group": "Transporte"
  },
  {
    "name": "Ship",
    "icon": "ship",
    "class": "fa-ship",
    "group": "Transporte"
  },
  {
    "name": "Subway",
    "icon": "subway",
    "class": "fa-subway",
    "group": "Transporte"
  },
  {
    "name": "Gas Pump",
    "icon": "gas-pump",
    "class": "fa-gas-pump",
    "group": "Transporte"
  },
  {
    "name": "Taxi",
    "icon": "taxi",
    "class": "fa-taxi",
    "group": "Transporte"
  },
  {
    "name": "Truck",
    "icon": "truck",
    "class": "fa-truck",
    "group": "Transporte"
  },
  {
    "name": "Helicopter",
    "icon": "helicopter",
    "class": "fa-helicopter",
    "group": "Transporte"
  },
  {
    "name": "Charging Station",
    "icon": "charging-station",
    "class": "fa-charging-station",
    "group": "Transporte"
  },
  {
    "name": "Map",
    "icon": "map",
    "class": "fa-map",
    "group": "Transporte"
  },
  {
    "name": "Road",
    "icon": "road",
    "class": "fa-road",
    "group": "Transporte"
  },
  {
    "name": "Parking",
    "icon": "parking",
    "class": "fa-parking",
    "group": "Transporte"
  },
  {
    "name": "Street View",
    "icon": "street-view",
    "class": "fa-street-view",
    "group": "Transporte"
  },
  {
    "name": "Walking",
    "icon": "walking",
    "class": "fa-walking",
    "group": "Transporte"
  },
  {
    "name": "Traffic Light",
    "icon": "traffic-light",
    "class": "fa-traffic-light",
    "group": "Transporte"
  },
  {
    "name": "Shuttle Van",
    "icon": "shuttle-van",
    "class": "fa-shuttle-van",
    "group": "Transporte"
  },
  {
    "name": "Home",
    "icon": "home",
    "class": "fa-home",
    "group": "Moradia"
  },
  {
    "name": "Bed",
    "icon": "bed",
    "class": "fa-bed",
    "group": "Moradia"
  },
  {
    "name": "Couch",
    "icon": "couch",
    "class": "fa-couch",
    "group": "Moradia"
  },
  {
    "name": "Bath",
    "icon": "bath",
    "class": "fa-bath",
    "group": "Moradia"
  },
  {
    "name": "Toilet",
    "icon": "toilet",
    "class": "fa-toilet",
    "group": "Moradia"
  },
  {
    "name": "Door Open",
    "icon": "door-open",
    "class": "fa-door-open",
    "group": "Moradia"
  },
  {
    "name": "Lightbulb",
    "icon": "lightbulb",
    "class": "fa-lightbulb",
    "group": "Moradia"
  },
  {
    "name": "Plug",
    "icon": "plug",
    "class": "fa-plug",
    "group": "Moradia"
  },
  {
    "name": "Shower",
    "icon": "shower",
    "class": "fa-shower",
    "group": "Moradia"
  },
  {
    "name": "Tv",
    "icon": "tv",
    "class": "fa-tv",
    "group": "Moradia"
  },
  {
    "name": "Tools",
    "icon": "tools",
    "class": "fa-tools",
    "group": "Moradia"
  },
  {
    "name": "Paint Roller",
    "icon": "paint-roller",
    "class": "fa-paint-roller",
    "group": "Moradia"
  },
  {
    "name": "Fan",
    "icon": "fan",
    "class": "fa-fan",
    "group": "Moradia"
  },
  {
    "name": "Chair",
    "icon": "chair",
    "class": "fa-chair",
    "group": "Moradia"
  },
  {
    "name": "Hammer",
    "icon": "hammer",
    "class": "fa-hammer",
    "group": "Moradia"
  },
  {
    "name": "Warehouse",
    "icon": "warehouse",
    "class": "fa-warehouse",
    "group": "Moradia"
  },
  {
    "name": "Water",
    "icon": "water",
    "class": "fa-water",
    "group": "Moradia"
  },
  {
    "name": "Fire Extinguisher",
    "icon": "fire-extinguisher",
    "class": "fa-fire-extinguisher",
    "group": "Moradia"
  },
  {
    "name": "Key",
    "icon": "key",
    "class": "fa-key",
    "group": "Moradia"
  },
  {
    "name": "Lock",
    "icon": "lock",
    "class": "fa-lock",
    "group": "Moradia"
  },
  {
    "name": "Film",
    "icon": "film",
    "class": "fa-film",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Gamepad",
    "icon": "gamepad",
    "class": "fa-gamepad",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Futbol",
    "icon": "futbol",
    "class": "fa-futbol",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Headphones",
    "icon": "headphones",
    "class": "fa-headphones",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Theater Masks",
    "icon": "theater-masks",
    "class": "fa-theater-masks",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Tv",
    "icon": "tv",
    "class": "fa-tv",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Music",
    "icon": "music",
    "class": "fa-music",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Book",
    "icon": "book",
    "class": "fa-book",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Camera",
    "icon": "camera",
    "class": "fa-camera",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Chess",
    "icon": "chess",
    "class": "fa-chess",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Dice",
    "icon": "dice",
    "class": "fa-dice",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Guitar",
    "icon": "guitar",
    "class": "fa-guitar",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Play",
    "icon": "play",
    "class": "fa-play",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Ticket Alt",
    "icon": "ticket-alt",
    "class": "fa-ticket-alt",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Puzzle Piece",
    "icon": "puzzle-piece",
    "class": "fa-puzzle-piece",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Palette",
    "icon": "palette",
    "class": "fa-palette",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Microphone",
    "icon": "microphone",
    "class": "fa-microphone",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Laugh",
    "icon": "laugh",
    "class": "fa-laugh",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Bowling Ball",
    "icon": "bowling-ball",
    "class": "fa-bowling-ball",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Drum",
    "icon": "drum",
    "class": "fa-drum",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Book",
    "icon": "book",
    "class": "fa-book",
    "group": "Educação"
  },
  {
    "name": "Graduation Cap",
    "icon": "graduation-cap",
    "class": "fa-graduation-cap",
    "group": "Educação"
  },
  {
    "name": "Chalkboard Teacher",
    "icon": "chalkboard-teacher",
    "class": "fa-chalkboard-teacher",
    "group": "Educação"
  },
  {
    "name": "Pen",
    "icon": "pen",
    "class": "fa-pen",
    "group": "Educação"
  },
  {
    "name": "Pencil Alt",
    "icon": "pencil-alt",
    "class": "fa-pencil-alt",
    "group": "Educação"
  },
  {
    "name": "Highlighter",
    "icon": "highlighter",
    "class": "fa-highlighter",
    "group": "Educação"
  },
  {
    "name": "Laptop",
    "icon": "laptop",
    "class": "fa-laptop",
    "group": "Educação"
  },
  {
    "name": "Microscope",
    "icon": "microscope",
    "class": "fa-microscope",
    "group": "Educação"
  },
  {
    "name": "Atom",
    "icon": "atom",
    "class": "fa-atom",
    "group": "Educação"
  },
  {
    "name": "School",
    "icon": "school",
    "class": "fa-school",
    "group": "Educação"
  },
  {
    "name": "University",
    "icon": "university",
    "class": "fa-university",
    "group": "Educação"
  },
  {
    "name": "User Graduate",
    "icon": "user-graduate",
    "class": "fa-user-graduate",
    "group": "Educação"
  },
  {
    "name": "Notebook",
    "icon": "notebook",
    "class": "fa-notebook",
    "group": "Educação"
  },
  {
    "name": "Glasses",
    "icon": "glasses",
    "class": "fa-glasses",
    "group": "Educação"
  },
  {
    "name": "Calendar Alt",
    "icon": "calendar-alt",
    "class": "fa-calendar-alt",
    "group": "Educação"
  },
  {
    "name": "Paperclip",
    "icon": "paperclip",
    "class": "fa-paperclip",
    "group": "Educação"
  },
  {
    "name": "Folder",
    "icon": "folder",
    "class": "fa-folder",
    "group": "Educação"
  },
  {
    "name": "Ruler",
    "icon": "ruler",
    "class": "fa-ruler",
    "group": "Educação"
  },
  {
    "name": "Compass",
    "icon": "compass",
    "class": "fa-compass",
    "group": "Educação"
  },
  {
    "name": "Abacus",
    "icon": "abacus",
    "class": "fa-abacus",
    "group": "Educação"
  },
  {
    "name": "Heartbeat",
    "icon": "heartbeat",
    "class": "fa-heartbeat",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Stethoscope",
    "icon": "stethoscope",
    "class": "fa-stethoscope",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Medkit",
    "icon": "medkit",
    "class": "fa-medkit",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Pills",
    "icon": "pills",
    "class": "fa-pills",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Syringe",
    "icon": "syringe",
    "class": "fa-syringe",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Tooth",
    "icon": "tooth",
    "class": "fa-tooth",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Spa",
    "icon": "spa",
    "class": "fa-spa",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Dumbbell",
    "icon": "dumbbell",
    "class": "fa-dumbbell",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "First Aid",
    "icon": "first-aid",
    "class": "fa-first-aid",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Soap",
    "icon": "soap",
    "class": "fa-soap",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Thermometer",
    "icon": "thermometer",
    "class": "fa-thermometer",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Band Aid",
    "icon": "band-aid",
    "class": "fa-band-aid",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Apple Alt",
    "icon": "apple-alt",
    "class": "fa-apple-alt",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Lungs",
    "icon": "lungs",
    "class": "fa-lungs",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Brain",
    "icon": "brain",
    "class": "fa-brain",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "User Nurse",
    "icon": "user-nurse",
    "class": "fa-user-nurse",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Hospital",
    "icon": "hospital",
    "class": "fa-hospital",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Vial",
    "icon": "vial",
    "class": "fa-vial",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Weight",
    "icon": "weight",
    "class": "fa-weight",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Tint",
    "icon": "tint",
    "class": "fa-tint",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Shopping Cart",
    "icon": "shopping-cart",
    "class": "fa-shopping-cart",
    "group": "Compras"
  },
  {
    "name": "Shopping Bag",
    "icon": "shopping-bag",
    "class": "fa-shopping-bag",
    "group": "Compras"
  },
  {
    "name": "Store",
    "icon": "store",
    "class": "fa-store",
    "group": "Compras"
  },
  {
    "name": "Tags",
    "icon": "tags",
    "class": "fa-tags",
    "group": "Compras"
  },
  {
    "name": "Credit Card",
    "icon": "credit-card",
    "class": "fa-credit-card",
    "group": "Compras"
  },
  {
    "name": "Cash Register",
    "icon": "cash-register",
    "class": "fa-cash-register",
    "group": "Compras"
  },
  {
    "name": "Receipt",
    "icon": "receipt",
    "class": "fa-receipt",
    "group": "Compras"
  },
  {
    "name": "Box",
    "icon": "box",
    "class": "fa-box",
    "group": "Compras"
  },
  {
    "name": "Gift",
    "icon": "gift",
    "class": "fa-gift",
    "group": "Compras"
  },
  {
    "name": "Cart Arrow Down",
    "icon": "cart-arrow-down",
    "class": "fa-cart-arrow-down",
    "group": "Compras"
  },
  {
    "name": "Barcode",
    "icon": "barcode",
    "class": "fa-barcode",
    "group": "Compras"
  },
  {
    "name": "Store Alt",
    "icon": "store-alt",
    "class": "fa-store-alt",
    "group": "Compras"
  },
  {
    "name": "Bag Shopping",
    "icon": "bag-shopping",
    "class": "fa-bag-shopping",
    "group": "Compras"
  },
  {
    "name": "Percent",
    "icon": "percent",
    "class": "fa-percent",
    "group": "Compras"
  },
  {
    "name": "Wallet",
    "icon": "wallet",
    "class": "fa-wallet",
    "group": "Compras"
  },
  {
    "name": "Money Bill",
    "icon": "money-bill",
    "class": "fa-money-bill",
    "group": "Compras"
  },
  {
    "name": "Price Tag",
    "icon": "price-tag",
    "class": "fa-price-tag",
    "group": "Compras"
  },
  {
    "name": "Dollar Sign",
    "icon": "dollar-sign",
    "class": "fa-dollar-sign",
    "group": "Compras"
  },
  {
    "name": "Coins",
    "icon": "coins",
    "class": "fa-coins",
    "group": "Compras"
  },
  {
    "name": "Exchange Alt",
    "icon": "exchange-alt",
    "class": "fa-exchange-alt",
    "group": "Compras"
  },
  {
    "name": "Briefcase",
    "icon": "briefcase",
    "class": "fa-briefcase",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Money Bill Wave",
    "icon": "money-bill-wave",
    "class": "fa-money-bill-wave",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Wallet",
    "icon": "wallet",
    "class": "fa-wallet",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Chart Line",
    "icon": "chart-line",
    "class": "fa-chart-line",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Hand Holding Usd",
    "icon": "hand-holding-usd",
    "class": "fa-hand-holding-usd",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Business Time",
    "icon": "business-time",
    "class": "fa-business-time",
    "group": "Trabalho e Renda"
  },
  {
    "name": "User Tie",
    "icon": "user-tie",
    "class": "fa-user-tie",
    "group": "Trabalho e Renda"
  },
  {
    "name": "File Invoice",
    "icon": "file-invoice",
    "class": "fa-file-invoice",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Calculator",
    "icon": "calculator",
    "class": "fa-calculator",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Suitcase",
    "icon": "suitcase",
    "class": "fa-suitcase",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Landmark",
    "icon": "landmark",
    "class": "fa-landmark",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Piggy Bank",
    "icon": "piggy-bank",
    "class": "fa-piggy-bank",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Clipboard",
    "icon": "clipboard",
    "class": "fa-clipboard",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Money Check",
    "icon": "money-check",
    "class": "fa-money-check",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Balance Scale",
    "icon": "balance-scale",
    "class": "fa-balance-scale",
    "group": "Trabalho e Renda"
  },
  {
    "name": "File Contract",
    "icon": "file-contract",
    "class": "fa-file-contract",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Chart Pie",
    "icon": "chart-pie",
    "class": "fa-chart-pie",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Id Badge",
    "icon": "id-badge",
    "class": "fa-id-badge",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Project Diagram",
    "icon": "project-diagram",
    "class": "fa-project-diagram",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Users",
    "icon": "users",
    "class": "fa-users",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Hand Holding Usd",
    "icon": "hand-holding-usd",
    "class": "fa-hand-holding-usd",
    "group": "Receita"
  },
  {
    "name": "Money Bill Wave",
    "icon": "money-bill-wave",
    "class": "fa-money-bill-wave",
    "group": "Receita"
  },
  {
    "name": "Wallet",
    "icon": "wallet",
    "class": "fa-wallet",
    "group": "Receita"
  },
  {
    "name": "Chart Line",
    "icon": "chart-line",
    "class": "fa-chart-line",
    "group": "Receita"
  },
  {
    "name": "Donate",
    "icon": "donate",
    "class": "fa-donate",
    "group": "Receita"
  },
  {
    "name": "Credit Card",
    "icon": "credit-card",
    "class": "fa-credit-card",
    "group": "Receita"
  },
  {
    "name": "Dollar Sign",
    "icon": "dollar-sign",
    "class": "fa-dollar-sign",
    "group": "Receita"
  },
  {
    "name": "Coins",
    "icon": "coins",
    "class": "fa-coins",
    "group": "Receita"
  },
  {
    "name": "Piggy Bank",
    "icon": "piggy-bank",
    "class": "fa-piggy-bank",
    "group": "Receita"
  },
  {
    "name": "Money Check",
    "icon": "money-check",
    "class": "fa-money-check",
    "group": "Receita"
  },
  {
    "name": "File Invoice Dollar",
    "icon": "file-invoice-dollar",
    "class": "fa-file-invoice-dollar",
    "group": "Receita"
  },
  {
    "name": "Landmark",
    "icon": "landmark",
    "class": "fa-landmark",
    "group": "Receita"
  },
  {
    "name": "User Tie",
    "icon": "user-tie",
    "class": "fa-user-tie",
    "group": "Receita"
  },
  {
    "name": "Money Check Alt",
    "icon": "money-check-alt",
    "class": "fa-money-check-alt",
    "group": "Receita"
  },
  {
    "name": "Receipt",
    "icon": "receipt",
    "class": "fa-receipt",
    "group": "Receita"
  },
  {
    "name": "Cash Register",
    "icon": "cash-register",
    "class": "fa-cash-register",
    "group": "Receita"
  },
  {
    "name": "Balance Scale",
    "icon": "balance-scale",
    "class": "fa-balance-scale",
    "group": "Receita"
  },
  {
    "name": "Briefcase",
    "icon": "briefcase",
    "class": "fa-briefcase",
    "group": "Receita"
  },
  {
    "name": "Chart Pie",
    "icon": "chart-pie",
    "class": "fa-chart-pie",
    "group": "Receita"
  },
  {
    "name": "Building",
    "icon": "building",
    "class": "fa-building",
    "group": "Receita"
  },
  {
    "name": "Laptop",
    "icon": "laptop",
    "class": "fa-laptop",
    "group": "Tecnologia"
  },
  {
    "name": "Mobile Alt",
    "icon": "mobile-alt",
    "class": "fa-mobile-alt",
    "group": "Tecnologia"
  },
  {
    "name": "Tablet Alt",
    "icon": "tablet-alt",
    "class": "fa-tablet-alt",
    "group": "Tecnologia"
  },
  {
    "name": "Desktop",
    "icon": "desktop",
    "class": "fa-desktop",
    "group": "Tecnologia"
  },
  {
    "name": "Server",
    "icon": "server",
    "class": "fa-server",
    "group": "Tecnologia"
  },
  {
    "name": "Wifi",
    "icon": "wifi",
    "class": "fa-wifi",
    "group": "Tecnologia"
  },
  {
    "name": "Satellite",
    "icon": "satellite",
    "class": "fa-satellite",
    "group": "Tecnologia"
  },
  {
    "name": "Microchip",
    "icon": "microchip",
    "class": "fa-microchip",
    "group": "Tecnologia"
  },
  {
    "name": "Keyboard",
    "icon": "keyboard",
    "class": "fa-keyboard",
    "group": "Tecnologia"
  },
  {
    "name": "Mouse",
    "icon": "mouse",
    "class": "fa-mouse",
    "group": "Tecnologia"
  },
  {
    "name": "Camera",
    "icon": "camera",
    "class": "fa-camera",
    "group": "Tecnologia"
  },
  {
    "name": "Tv",
    "icon": "tv",
    "class": "fa-tv",
    "group": "Tecnologia"
  },
  {
    "name": "Code",
    "icon": "code",
    "class": "fa-code",
    "group": "Tecnologia"
  },
  {
    "name": "Cloud",
    "icon": "cloud",
    "class": "fa-cloud",
    "group": "Tecnologia"
  },
  {
    "name": "Database",
    "icon": "database",
    "class": "fa-database",
    "group": "Tecnologia"
  },
  {
    "name": "Network Wired",
    "icon": "network-wired",
    "class": "fa-network-wired",
    "group": "Tecnologia"
  },
  {
    "name": "Robot",
    "icon": "robot",
    "class": "fa-robot",
    "group": "Tecnologia"
  },
  {
    "name": "Usb",
    "icon": "usb",
    "class": "fa-usb",
    "group": "Tecnologia"
  },
  {
    "name": "Ethernet",
    "icon": "ethernet",
    "class": "fa-ethernet",
    "group": "Tecnologia"
  },
  {
    "name": "Sim Card",
    "icon": "sim-card",
    "class": "fa-sim-card",
    "group": "Tecnologia"
  },
{
    "name": "Assinaturas",
    "icon": "file-invoice",
    "class": "fa-file-invoice",
    "group": "Serviços"
  },
  {
    "name": "Contador/Impostos",
    "icon": "receipt",
    "class": "fa-receipt",
    "group": "Serviços"
  },
  {
    "name": "Multas e taxas",
    "icon": "gavel",
    "class": "fa-gavel",
    "group": "Serviços"
  },
  {
    "name": "Serviços bancários",
    "icon": "university",
    "class": "fa-university",
    "group": "Serviços"
  },
  {
    "name": "Presentes",
    "icon": "gift",
    "class": "fa-gift",
    "group": "Outros"
  },
  {
    "name": "Doações",
    "icon": "hand-holding-heart",
    "class": "fa-hand-holding-heart",
    "group": "Outros"
  },
  {
    "name": "Imprevistos",
    "icon": "exclamation-triangle",
    "class": "fa-exclamation-triangle",
    "group": "Outros"
  }
]


const getIcons = async () => {

    let mapped_groups = {};

    icons_new.forEach((item) => {

        if(mapped_groups[item.group]){

            mapped_groups[item.group].push(item);

        }
        else{
            mapped_groups[item.group] = [];
            mapped_groups[item.group].push(item);
        }

    });

    icons = mapped_groups;

}

const store = useStore();

const darkMode = computed(() => store.state.darkMode);

onBeforeMount(() => {

    validSession.isLogged();

    store.state.transaction_value = {
        value: 0
    }

    store.state.objetive_icon = 'fa-receipt';
    store.state.objetive_color = '#000'
    store.state.objetive_name = '';
    store.state.objetive_target = 0;
    store.state.objetive_discount = 0;
    store.state.objetive_account = 0;
    store.state.objetive_id = '';

    store.state.accounts = [];
    store.state.objetives = [];
    
    store.state.loadingObjetives = true;
    store.state.savingObjetive = false;

    store.state.savingTransaction = false;

    store.state.validation = {
        nameHasError: false,
        nameMessageError: '',
        accountHasError: false,
        accountMessageError: '',
    };

    store.state.deleted_category = {};
    store.state.destiny_category = 0;

    store.state.toArchive = {
        icon: '',
        name: '',
    };

    let day = new Date().getDate();
    let month = new Date().getMonth() + 1;
    let year = new Date().getFullYear();

    store.state.current_date = year+ '-' + (month < 10 ? '0'+month : month) + '-' + (day < 10 ? '0'+ day : day);

    store.state.transation = {
        type: '',
        amount: 0,
        date: store.state.current_date,
        objetive_id: 0,
        objetive_name: ''
    }

    store.state.modalColor = '';

    getObjetives();
    getIcons();
    getAccounts();
    
});

const clearFields = () => {
    store.state.objetive_icon = 'fa-receipt';
    store.state.objetive_color = '#000'
    store.state.objetive_name = '';
    store.state.objetive_target = 0;
    store.state.objetive_discount = 0;
    store.state.objetive_account = 0;
    store.state.objetive_id = '';
}

const openModal = (id) => {

    let modal = bootstrap.Modal.getOrCreateInstance(document.getElementById(id));

    modal.show();

}

const getContrastYIQ = (hexcolor) => {
    var r = parseInt(hexcolor.substring(1,3),16);
    var g = parseInt(hexcolor.substring(3,5),16);
    var b = parseInt(hexcolor.substring(5,7),16);
    var yiq = ((r*299)+(g*587)+(b*114))/1000;
    return (yiq >= 128) ? 'black' : 'white';
}

const getAccounts = async () => {

    axios.get('accounts?archived=No')
    .then(res => {
        
        if(res.status == 200){

            store.state.accounts = res.data;

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const getObjetives = async () => {

    store.state.loadingObjetives = true;

    axios.get('objetives')
    .then(res => {
        
        if(res.status == 200){

            store.state.objetives = res.data;
            store.state.loadingObjetives = false;

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const closeModal = (id) => {

    let modal = bootstrap.Modal.getOrCreateInstance(document.getElementById(id));

    modal.hide();

}

const submit_objetive = async () => {

    let data = new FormData();

    store.state.validation.nameHasError = false;
    store.state.validation.accountHasError = false;

    store.state.objetive_target = value_objetive.value.replace('R$ ', '');

    data.append('name', store.state.objetive_name);
    data.append('icon', store.state.objetive_icon);
    data.append('color', store.state.objetive_color);
    data.append('target', store.state.objetive_target);
    data.append('discount', store.state.objetive_discount == true ? 'Yes' : 'No');
    data.append('account_id', store.state.objetive_discount == true ? store.state.objetive_account : 0);

    let url = '/objetives';
    let toast_message = 'Objetivo criado com sucesso!';

    if(store.state.objetive_id != ''){
        url = '/objetives/update/'+store.state.objetive_id;
        toast_message = 'Objetivo atualizado com sucesso!';
    }

    await axios.post(url, data)
    .then(res => {

        if(res.data.error){

            let messages = res.data.messages;

            Object.entries(messages).forEach((value) => {

                if(value[0] == 'name'){
                    store.state.validation.nameHasError = true;
                    store.state.validation.nameMessageError = value[1];
                }

                else if(value[0] == 'parent_id'){
                    store.state.validation.parentHasError = true;
                    store.state.validation.parentMessageError = value[1];
                }


            })

        }
        else{

            store.state.validation = {
                nameHasError: false,
                nameMessageError: '',
                accountHasError: false,
                accountMessageError: '',
            };

            closeModal('addObjetiveModal');

            clearFields();

            getObjetives();

            toast(toast_message, {
                autoClose: 1000,
                theme: "auto",
                type: "success",
                transition: "slide"
            });

        }

    })
    .catch(err => {
    console.error(err); 
    })

}

const editObjetive = (data) => {

    value_objetive.value = formatMoney(data.target);

    store.state.objetive_icon = data.icon;
    store.state.objetive_color = data.color
    store.state.objetive_name = data.name;
    store.state.objetive_target = data.target;
    store.state.objetive_discount =  data.discount == 'Yes' ? true : false;
    store.state.objetive_account = data.account_id;
    store.state.objetive_id = data.id;

}

function formatMoney(v) {
      let total = parseFloat(v);

      return total.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
}

const deleteObjetive = async (objetive) => {

    store.state.toArchive = {
        icon: objetive.icon,
        name: objetive.name,
    };

    openModal('deleteObjetive');

    var confirmButton = document.getElementById('confirmExclusionObjetiveButton');
    confirmButton.addEventListener('click', async function () {
    // do something...

        //console.log('clicou');

        let url = '/objetives/delete/'+objetive.id;
        let toast_message = 'Objetivo excluído com sucesso!';

        await axios.post(url)
        .then(res => {

            if(res.data.error){

                console.log(res);

            }
            else{

                toast(toast_message, {
                    autoClose: 1000,
                    theme: "auto",
                    type: "success",
                    transition: "slide"
                });

                closeModal('deleteObjetive');
                
                getObjetives();

            }

        })
        .catch(err => {
            console.error(err); 
        })
        

    })

}

const setTypeObj = (data, type) => {

    if(type == 'retirada'){
        store.state.modalColor = '-warning';
    }
    else if(type == 'deposito'){
        store.state.modalColor = '-success';
    }

    store.state.transation.type = type;
    store.state.transation.objetive_id = data.id;
    store.state.transation.objetive_name = data.name;

}

const clearFieldsTransaction = () => {

    store.state.transation = {
        type: '',
        amount: 0,
        date: store.state.current_date,
        objetive_id: 0,
        objetive_name: ''
    }

    store.state.transaction_value = {
        value: 0
    }

}

const submitTransaction = async () => {

    store.state.savingTransaction = true;

    let data = new FormData();

    store.state.transation.amount = store.state.transaction_value.value.replace('R$ ', '');

    //console.log(store.state.transation.amount);

    data.append('type', store.state.transation.type);
    data.append('amount', store.state.transation.amount);
    data.append('date', store.state.transation.date);
    data.append('objetive_id', store.state.transation.objetive_id);

    let url = '/objetives/transactions';
    let toast_message = 'Transação criado com sucesso!';

    await axios.post(url, data)
    .then(res => {

        if(res.data.error){

            let messages = res.data.messages;

            Object.entries(messages).forEach((value) => {

                if(value[0] == 'description'){
                    store.state.validation.descHasError = true;
                    store.state.validation.descMessageError = value[1];
                }
                else if(value[0] == 'account'){
                    store.state.validation.accountError = true;
                    store.state.validation.accountMessageError = value[1];
                }
                else if(value[0] == 'category'){
                    store.state.validation.categorryError = true;
                    store.state.validation.categoryMessageError = value[1];
                }

            })

            store.state.savingTransaction = false;

        }
        else{

            store.state.validation = {
                descHasError: false,
                descMessageError: '',
            };

            closeModal('addTransactionObj');

            toast(toast_message, {
                autoClose: 1000,
                theme: "auto",
                type: "success",
                transition: "slide"
            });

            store.state.savingTransaction = false;

            getObjetives();
            clearFieldsTransaction();

        }

    })
    .catch(err => {
        console.error(err); 

        toast('Não foi possível realizar a operação, tente mais tarde (Erro '+err.response.status+')', {
            autoClose: 1000,
            theme: "auto",
            type: "error",
            transition: "slide"
        });

        store.state.savingTransaction = false;

    })

}

</script>

<template>
    <div class="py-4 container-fluid overflow-auto max-height-vh-80 min-height-600">

        <div class="row">
            <div class="col-12"></div>
        </div>

        <div class="card">

            <div class="card-header pb-0">
                <div class="row align-items-center mb-n2 mb-md-2 mt-md-n2">
                    <div class="col-6">
                        <h6 class="text-white">Objetivos</h6>
                    </div>
                    <div class="col-6 text-end">
                        <a 
                            class="me-3 trasation-list-add-button mt-n1 mb-2 text-white"
                            type="button" 
                            id="dropdownMenuButton1"
                            @click="openModal('addObjetiveModal')"
                            >
                            <i class="fal fa-plus-circle"></i> <span class="d-none d-lg-inline-flex">Acidionar</span>
                        </a>
                        
                    </div>
                </div>
            </div>

            <div class="card-body px-0 pt-0 pb-2">

                <div class="col-12">

                    <div class="row">

                        <div class="col-12 text-center mt-4" v-if="store.state.loadingObjetives">
                            <img :src="loadGif" alt="" width="60px">
                        </div>
                        <div class="col-12 text-center mt-4" v-if="store.state.objetives.length == 0 && !store.state.loadingObjetives">
                            <p>Nenhum objetivo cadastrado.</p>
                        </div>
                        <div class="col-12 mt-4 mb-4" v-if="!store.state.loadingObjetives">

                            <ObjetivesRow
                                v-for="(objetive, index) in store.state.objetives" :key="index"
                                :objetive="objetive"
                                :id="objetive.id"
                                :darkmode = darkMode
                                @edit="editObjetive"
                                @setType="setTypeObj"
                                @delete="deleteObjetive"
                            />

                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>

    <div class="modal fade" id="addObjetiveModal" tabindex="-1" aria-labelledby="addObjetiveModalLabel" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content"
                v-bind:class="{
                        'darkmode': darkMode,
                    }"
            >
                <div class="modal-body" :class="darkMode ? 'darkmode' : ''">
                    <div class="row">

                        <div class="col-10">
                            <b>
                                Criando um Objetivo
                            </b>
                        </div>

                        <div class="col-2 text-end">
                            <a type="button" data-bs-dismiss="modal" @click="clearFields()">
                                <i class="fal fa-times-circle fa-lg"></i>
                            </a>
                        </div>

                        <div class="col-11 mx-auto">

                            <div class="row align-items-center mt-5">
                                <div class="col-3 category-create-icon-div">

                                    <div class="text-center shadow icon icon-shape align-self-center rounded-5 ms-2 me-3" :style="'background-color: '+store.state.objetive_color">
                                        <i :class="'icon-create fal ' + store.state.objetive_icon" :style="'color:'+getContrastYIQ(store.state.objetive_color)"></i>
                                    </div>

                                </div>
                                <div class="col-9 mb-3">

                                    <label for="ObjetiveName">Nome do objetivo</label>
                                    <input 
                                        type="text" 
                                        class="form-control form-control-lg" 
                                        id="ObjetiveName"
                                        name="ObjetiveName"
                                        placeholder="Nome do objetivo"
                                        v-model="store.state.objetive_name"
                                        v-bind:class="{
                                            'is-invalid': store.state.validation.nameHasError,
                                            'darkmode': darkMode,
                                        }"
                                    >
                                    <div id="objetiveNameFeedback" class="invalid-feedback">
                                        {{ store.state.validation.nameMessageError }}
                                    </div>                                    

                                </div>
                                <div class="col-12 mb-3">
                                    <label for="transactionAmount">Meta do objetivo</label>
                                    <input 
                                        type="tel" 
                                        class="form-control form-control-lg" 
                                        id="objetiveAmount"
                                        name="objetiveAmount"
                                        v-model.lazy="value_objetive.value" 
                                        v-money="money"
                                        v-bind:class="{
                                            'darkmode': darkMode,
                                        }"
                                    >
                                </div>
                                <div class="col-12 mb-1">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" v-model="store.state.objetive_discount">
                                        <label class="form-check-label" for="flexCheckDefault">
                                            Criar transação automatica na conta
                                        </label>
                                    </div>
                                </div>
                                <div v-if="store.state.objetive_discount" class="col-12 mb-3">
                                    <label for="categoryName">Criar transação na conta:</label>
                                    <select 
                                        class="form-select form-select-lg" 
                                        aria-label="Conta" 
                                        v-model="store.state.objetive_account"
                                        id="parentSelect"
                                        v-bind:class="{
                                            'is-invalid': store.state.validation.accountError,
                                            'darkmode': darkMode,
                                        }"
                                    >
                                            <option value="0" selected disabled>Selecione a conta</option>
                                            <option
                                                v-for="(account, index) in store.state.accounts" :key="index"
                                                :value="account.id"
                                            >
                                                {{ account.name }}
                                            </option>
                                    </select>
                                    <div id="accountSelectFeedback" class="invalid-feedback">
                                        {{ store.state.validation.accountMessageError }}
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-2">
                                <hr>
                            </div>

                            <div class="row">

                                <div class="col-12">
                                    <p>Escolha um icone</p>
                                </div>

                                <div class="col-12 icon-list">

                                    <div class="row justify-content-center">

                                        <div v-for="(groups, index) in icons" :key="index" class="col-12">
                                            <div class="col-12">
                                                <span class="text-xs font-weight-bold">{{ index }}</span>
                                            </div>
                                            <div class="col-12">

                                                <div class="row">

                                                    <div
                                                        v-for="(icon, i) in groups" :key="i"
                                                        @click="store.state.objetive_icon = icon.class"
                                                        class="color-picker rounded-5 d-flex align-items-center"
                                                        :class="darkMode ? 'text-white' : 'text-dark'"
                                                    >
                                                        <i :class="'ms-n1 fal '+icon.class"></i>
                                                    </div>

                                                </div>

                                            </div>
                                        </div>


                                    </div>

                                </div>
                                
                            </div>

                            <div class="row mt-2 mb-2">
                                <hr>
                            </div>

                            <div class="row">

                                <div class="col-12">
                                    <p>Escolha uma cor</p>
                                </div>
                                
                                <div class="col-12 icon-list">

                                    <div class="row">

                                        <div
                                        v-for="(color, index) in colors" :key="index"
                                        @click="store.state.objetive_color = color"
                                        class="color-picker rounded-5" 
                                        :style="'background-color: '+color+';'"
                                        ></div>

                                    </div>

                                </div>
                            </div>

                            <div class="row mt-2 mb-2">
                                <hr>
                            </div>

                            <div class="row">
                                <div class="col-12 mt-3 mb-3 text-center">
                                    <button 
                                        @click="submit_objetive()"
                                        class="btn btn-success"
                                    >
                                        {{ store.state.objetive_id == '' ? "Criar Objetivo" : "Salvar Alterações" }}
                                    </button>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
                
            </div>
        </div>
    </div>

    <div class="modal fade" id="deleteObjetive" tabindex="-1" aria-labelledby="deleteObjetiveModal" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content"
                v-bind:class="{
                            'darkmode': darkMode,
                        }"
            >
                <div class="modal-body" :class="darkMode ? 'darkmode' : ''">
                    <div class="col-11 mx-auto mt-4 mb-4">
                        <h5 class="mb-4">Você quer mesmo excluir esse objetivo?</h5>

                        <div class="col-12 col-lg-10 mx-auto text-start mt-3 mb-3">
                            <p>
                                <b>Exclusão permanente de objetivo</b>
                                <ul>
                                    <li>Não será possível recuperar este objetivo.</li>
                                </ul>
                            </p>
                            <p>
                                <b>Atenção!</b> Esta operação é irreversível!
                            </p>
                        </div>

                    </div>
                    <div class="col-12 text-center">
                        <button
                            id="confirmExclusionObjetiveButton" 
                            class="btn btn-danger"
                        >
                            Excluir permanentemente
                        </button>

                        <a @click="closeModal('deleteObjetive')" class="btn btn-link">Cancelar</a>
                    </div>
                </div>
                
            </div>
        </div>
    </div>

    <div class="modal fade" id="addTransactionObj" tabindex="-1" aria-labelledby="addTransactionObj" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content border-4" v-bind:class="{
                        'darkmode': darkMode,
                        'border-success': store.state.transation.type == 'deposito',
                        'border-warning': store.state.transation.type == 'retirada',
                    }">
                <div class="modal-body" :class="darkMode ? 'darkmode' : ''">
                    <div class="row">
                        <div class="col-10">
                            <b>
                                {{ store.state.transation.type == 'deposito' ? 'Novo' : 'Nova' }} {{ store.state.transation.type }} em {{ store.state.transation.objetive_name }}
                            </b>
                        </div>
                        <div class="col-2 text-end">
                            <a type="button" data-bs-dismiss="modal" @click="clearFieldsTransaction()">
                                <i class="fal fa-times-circle fa-lg"></i>
                            </a>
                        </div>

                        <div class="col-12 col-lg-11 mx-auto mt-3 mb-3">

                            <div class="row">

                                <div class="col-6 mb-3">
                                    <label for="transactionAmount">
                                        Valor                                     
                                    </label>
                                    <input 
                                        type="tel" 
                                        class="form-control form-control-lg" 
                                        id="transactionAmount"
                                        name="transactionAmount"
                                        v-model.lazy="store.state.transaction_value.value" 
                                        v-money="money"
                                        v-bind:class="{
                                            'darkmode': darkMode,
                                        }"
                                    >
                                </div>

                                <div class="col-6 mb-3">
                                    <label for="transactionDate">Data</label>
                                    <input 
                                        type="date" 
                                        class="form-control form-control-lg" 
                                        id="transactionDate"
                                        name="transactionDate"
                                        v-model="store.state.transation.date"
                                        v-bind:class="{
                                            'darkmode': darkMode,
                                        }"
                                    >
                                </div>

                                <div class="col-12 text-center mt-4 mb-n4">
                                    <button
                                        v-if="!store.state.savingTransaction"
                                        @click="submitTransaction()"
                                        class="btn"
                                        :class="'btn'+store.state.modalColor"
                                    >
                                        Salvar
                                    </button>
                                    <img v-if="store.state.savingTransaction" :src="loadGif" alt="" width="50">
                                </div>
                                
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>